// Presentation metadata only. Calculations remain in the shared API.
const config = Object.freeze({
  endpoint: '/api/calculators/growth-required/calculate',
  fields: ['transferValue', 'illustrationDate', 'retirementDate', 'targetFundValue', 'newPlanReductionInYieldPercent'],
  example: [693, '2009-09-18', '2012-12-01', 825.28, 1.9],
  subject: 'growth estimate', initialMessage: 'Enter the transfer and target details to calculate the required growth.',
  validationMessage: 'Enter a finite numeric value.', successMessage: 'Growth calculated using the workbook method.',
  outputLabels: { requiredNetAnnualGrowthRate: 'Required net growth', requiredGrossAnnualGrowthRate: 'Growth per year including RIY' }
});
export default config;
